export const BRAND = {
    id: 0,
    context_id: 0,
    page: 1,
    sort: 'internal',
    direction: 'desc',
    load_goods: function(append) {
        $.post(
            '/aj',
            {
                action: 'brand',
                to: 'goods',
                id: this.id,
                context_id: this.context_id,
                page: this.page,
                sort: this.sort,
                direction: this.direction
            },
            function(data) {
                if (append)
                    $(".brand-goods .looplist").append(data.html);
                else
                    $(".brand-goods .looplist").html(data.html);

                fill_lines();

                if (!data.more)
                    $('.brand-goods .show-more').addClass('hidden');
                else
                    $('.brand-goods .show-more').removeClass('hidden');
            },
            'json'
        );
    }
};

export function init_BRAND_events() {
    jQuery(document).ready(function () {

        $(".brand-main .blog-categories a").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().parent().find('a').removeClass('active');
            btn.addClass('active');

            $(".brand-pack >div").removeClass('hidden');

            if (btn.data('letter') == '') {
                $(".brand-pack").removeClass('hidden').removeClass('opened');
            } else {
                $(".brand-pack").addClass('hidden');
                $(".brand-pack[data-letter=" + btn.data('letter') + "]").removeClass('hidden').addClass('opened');
            }
        });

        $(".find-brand").submit(function (e) {
            e.preventDefault();
        });

        $(".find-brand [name=q]").keyup(function (e) {
            e.preventDefault();

            let input = $(this);
            let val = input.val().toUpperCase();

            if ($.trim(val) == '') {
                $(".brand-pack").removeClass('hidden');
                $(".brand-pack >div").removeClass('hidden');
            }

            $.each($(".brand-pack a"), (i, link) => {
                link = $(link);
                if (link.html().toUpperCase().indexOf(val) > -1) {
                    link.parent().removeClass('hidden');
                } else {
                    link.parent().addClass('hidden');
                }
            });

            $.each($(".brand-pack"), (i, index) => {
                let div = $(index);

                let count_hidden = div.find('.hidden').length + 0;
                let count_total = div.find('>div').length + 0;

                if (count_hidden == count_total) {
                    div.addClass('hidden').removeClass('opened');
                } else {
                    div.removeClass('hidden').addClass('opened');
                }
            });
        });

        $(".brand-pack h3").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().toggleClass('opened');
        });

        $(".brand-text .open").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().toggleClass('opened');
            btn.remove();
        });

        jQuery("body").on("click", ".brand-tabs a", function (e) {
            e.preventDefault();
            let btn = $(this);

            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            btn.parent().parent().find('.container__title .link').html(btn.data('name'));

            $.ajax({
                type: "POST",
                url: "/aj",
                data: {action: 'brand', to: 'tabs', locale: G.locale_id, id: btn.data('id'), type: btn.data('type')},
                success: (data) => {
                    $(".brand-tabs-container .looplist").html(data);
                    sliderAccessories(true);
                },
                error: (request, status, err) => {
                }
            });
        });

        jQuery("body").on("click", ".brand-context a", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            BRAND.context_id = btn.data('context');
            BRAND.page = 1;
            BRAND.load_goods();
        });

        jQuery("body").on("click", ".brand-goods .show-more", function (e) {
            e.preventDefault();
            e.stopPropagation();
            BRAND.page = BRAND.page + 1;
            BRAND.load_goods(true);
        });

        jQuery("body").on("click", ".brand-goods .sorting-toggle.active a", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            btn.parents('.sorting-toggle').removeClass('active');

            BRAND.sort = btn.data('sort');
            BRAND.direction = btn.data('direction');
            BRAND.page = 1;
            BRAND.load_goods();
        });

        if (!(typeof G.brand_id === "undefined"))
            BRAND.id = G.brand_id;

    });
}

init_BRAND_events();